<template>
  <vx-card id="packs">

    <div v-if="commercialOffer.type == 'PAQUETES'">
        <span class="title-style modify-title" style="display:inline-block; margin-bottom:8px">Elige la opción que consideres más adecuada. </span>
        <span class="subtitle-style modify-subtitle" style="display:inline-block; opacity: 0.7;">Incrementa tu protección en aquello que te importa y paga mensualmente. Así de fácil.</span>

            <div class="vx-card" v-if="packCommercialOffers">
              <div class="vx-row pack">
              <template v-if="packsCoverageChartCategories"  >
              <div class="vs-col md:w-1/3 p-4"  :key="'b'+indexDetail" v-for="(coverCategories, indexDetail) in packsCoverageChartCategories.commercialCoverChartCategory" >
                  <div class="vx-card bg-box-gradient table-test p-1" :id="changeTableId(indexDetail)"> 

                    <div class="pb-2 pt-1" :id="changeImageId(indexDetail)">
                      <img src="../../../../assets/images/pages/eCommerce/umbrella.png">
                      <span class="packName">{{coverCategories.packName}}</span><br>
                      <span class="packPrima">{{searchPackCommercialOffer(coverCategories.packName)}}</span>
                      <span class="packUnits"> €/{{getPaymentMethod()}}</span>
                    </div>


                      <div style="padding-bottom:50px">
                        <div class="vx-card mt-2 p-2">
                            <div class="pb-3 bullet-points" :key="'a'+indexCategory" v-for="(categories, indexCategory) in coverCategories.coverChartCategoryGroup">
                                  <span class="categoryName">{{categories.name}},</span>
                                  <span class="categoryDetail"> hasta: </span>
                                  <span class="categoryCapital">{{formatImporte(categories.capital)}}</span>
                          </div>
                        </div>
                      </div>

                      <div class="info-interested-div uneven-pack" >
                      <!-- Important the order of buttons, as direction is row-reverse: izq a dcha 
                      To avoid movement of buttons when i button not showed  -->

                        <vs-button
                          class="rounded-button right-button-pack"
                          @click="goToThirdStep(coverCategories.packName)"
                          >
                          Me interesa
                        </vs-button>

                        <vs-button
                          class="info-button"
                          @click="showCoverageChart(coverCategories.packName, indexDetail)">
                            &#9432;
                        </vs-button>
                      </div>

                </div>
              </div>
            </template>
              </div>
            </div>

          <div v-if="packCoverageChart">

            <vs-popup class="con-vs-popup coverage-popup" id="coverage-popup" :active.sync="coverageChartPop">
            <!-- <vs-popup  class="con-vs-popup"  :title="makeTitle(packCoverageChart.name, dataTablePackage[0].receipt)" :active.sync="coverageChartPop"> -->
              <coverage-chart-component
                  v-bind:coverageChart="packCoverageChart"
                  v-bind:dataTable="dataTablePackage"
                  v-bind:coverageChartPop="coverageChartPop"
                  @closeCoverageChartPop="closeCoverageChartPop"
              ></coverage-chart-component>
            </vs-popup>
          </div>
          <div>

          <navegation-buttons id= "buttons"
            v-bind:code="code"
            v-bind:previus="previus"
            >
          </navegation-buttons>

          </div>
      </div>
    </vx-card>
</template>

<script>
/* eslint-disable */
import VxCard from '../../../../components/vx-card/VxCard.vue'
import CoverageChartComponent from '../coverage-chart/CoverageChartComponent.vue'
import vSelect from 'vue-select'
// import CallServicePopup from '../callServicePopup/CallServicePopup.vue';
import NavegationButtons from '../navegationButtons/NavegationButtons.vue';

export default {
  components: { VxCard, 
                CoverageChartComponent,
                // CallServicePopup ,
                vSelect, 
                NavegationButtons},

    name: 'commercial-offer-pack',
    props: {
        commercialOffer: Object,
        code: String,
        next: String,
        previus: String,
    },
    data() {
        return {
          dataStored: null,
          initialData: null,
          packCommercialOffers: [],
          packCommercialOfferDetail: null,
          dataTablePackage: [],
          coverageChart: null,
          coverageChartPop: false,
          packsCoverageChartCategories: null,
          packsCoverageChart: null,
          packCoverageChart: null,
          filter: "",
          closeLoader: null,
          finalProcess:  null,
          
        }
    },
    created() {
        this.dataStored = JSON.parse(localStorage.getItem(this.code))
        this.initialData = this.dataStored.initialData

        if (this.dataStored.packCommercialOffers) {
            this.packCommercialOffers = this.dataStored.packCommercialOffers
            this.packsCoverageChartCategories =  this.dataStored.packsCoverageChartCategories
            this.packsCoverageChart = this.dataStored.packsCoverageChart
        } else {
            this.initView(this.initialData)
          }
    },

    methods: {
          initView(data) {
            this.getPackCommercialOffer(data)
            this.getCoverageChartCategories(data)
            this.getCoverageChart(data)
        },

        getPackCommercialOffer(data) {
           let changedDate = data.bornDate.replace(/(..)\-(..)\-(....)/, '$3-$2-$1');
            var date = new Date(changedDate);
            data.age = date.getTime();
            
            let commercialData = {
              bornDate: data.age,
              commercialCode: data.commercialCode,
              email: data.email,
              initialDataId: data.initialDataId,
              phone: data.phone,
              profession: data.profession,
              regime: data.regime,
            }

            this.packCommercialOffers = [];
            this.$http.post(process.env.VUE_APP_BROKER_API + '/commercialOffer/' + data.commercialCode, commercialData)
            .then((response) => {
              let packCommercialData = response.data;

              packCommercialData.forEach(pack => {
                    let packCommercialOffer = {
                        name: pack.name,
                        receipt: pack.primaMonth,
                        primaTotal: pack.prima
                    }

                    this.packCommercialOffers.push(packCommercialOffer);
                });

                this.dataStored.packCommercialOffers = this.packCommercialOffers
            })

        },

        getCoverageChartCategories(data) {
          this.$http.get(process.env.VUE_APP_BROKER_API + '/coverages-chart-categories/'+ data.commercialCode)
            .then((responseCategories) => {
              this.packsCoverageChartCategories = responseCategories.data;

              this.dataStored.packsCoverageChartCategories = this.packsCoverageChartCategories
            });
        },

        getCoverageChart(data) {
          this.$http.get(process.env.VUE_APP_BROKER_API + '/coverages-chart/'+ data.commercialCode)
          .then((response) => {
              this.packsCoverageChart = response.data;

              this.dataStored.packsCoverageChart = this.packsCoverageChart

          })
        },

        showCoverageChart(commercialPackage, indexDetail){
          this.showPackageDetail(commercialPackage, indexDetail);
          this.coverageChartPop = true;
        },

        showPackageDetail(commercialPackage, indexDetail) {
            this.dataTablePackage = [];
            this.packCoverageChart = this.packsCoverageChart.packOffer.filter(x => x.name == commercialPackage)[0]
            this.dataTablePackage.push( this.packCommercialOffers.filter(x => x.name == commercialPackage)[0])

            let params = {
              packIndex: "",
              paymentMethod: ""
            }
            params.packIndex = indexDetail
            params.paymentMethod = this.commercialOffer.paymentMethod
            this.dataTablePackage.push(params)

       },
      
        getPaymentMethod(){
           let paymentMethod = ""
           switch(this.commercialOffer.paymentMethod){
               case 1:
                   paymentMethod = "año"
                break;

               case 2:
                paymentMethod = "semestre"
                break;

               case 3:
                paymentMethod = "cuatrimestre"
                break;

               case 4:
                paymentMethod = "trimestre"
                break;

               case 6:
                paymentMethod = "bimensual"
                break;

               case 12:
                paymentMethod = "mes"
                break;
           }

           return paymentMethod
        },

        closeCoverageChartPop(value){
          this.coverageChartPop = value.closePop;
          if (value.packName != "") {

            this.goToThirdStep(value.packName)
          }  else{
            return true
          }
        },

        goToThirdStep(packName) {

          let params = {
            commercialOfferType: this.commercialOffer.type,
            commercialOfferCode: this.initialData.commercialCode,
            leadType: "BasicVendor",
            profession: this.initialData.profession,
            regime: this.initialData.regime,
            packName: packName,
            primaNeta: 0,
            primaTotal: 0
          }

            let products = [];

            this.dataStored.packSelected = packName

            this.$vs.loading({ type: "sound" });

           this.commercialOffer.coverPackages.filter(x => x.name == packName)[0].coverages.forEach( cover => {
               products.push(cover.productId)
           })
          
           params.primaNeta =  parseFloat(this.packCommercialOffers.filter(x => x.name == packName)[0].receipt.toFixed(2)),
           params.primaTotal =  parseFloat(this.packCommercialOffers.filter(x => x.name == packName)[0].primaTotal.toFixed(2))

        this.filter = '{ "_id": {$in: [';
          products.forEach( product => {
            this.filter += ' ObjectId("' + product + '"),';
          })
          this.filter += "]}}"

          let headers = {
            "Content-Type": "application/json",
            filter: this.filter
          }

          this.$http.get(process.env.VUE_APP_BROKER_API + '/products', { headers })
          .then((response) => {
              let files = []
              response.data.forEach(product => {
                if (product.requestId) {

                  files.push(product.requestId)
                }
              })
            this.dataStored.filesToSign = files
          })

          localStorage.setItem(this.code, JSON.stringify(this.dataStored))

          // var windowReference = window.open();

          this.$http.patch(process.env.VUE_APP_BROKER_API + '/initial-data/' + this.initialData.initialDataId, params)
          .then((response) => {

            this.$router
              .push("/" + this.next + "-step/" + this.code)
              .catch(() => {});

            // this.closeLoader = setInterval(async () => {
            //     this.localDataStored = JSON.parse(localStorage.getItem(this.code))
            //     if (this.localDataStored.signed == true)  {
            //         // Delete localStorage 
            //           localStorage.removeItem(this.code);

            //         this.$vs.loading.close()
            //         clearInterval(this.closeLoader)
            //         this.$router
            //             .push("/" +  this.code)
            //             .catch(() => {});
            //     }
            // }, 15000)

            // windowReference.location = process.env.VUE_APP_DOMAIN + '/' + this.next + '-step/' + this.code;
            // window.open(process.env.VUE_APP_DOMAIN + "/" + this.next + "-step/" + this.code, '_blank');
            
          })


        },
        changeTableId(indexDetail){
          return 'pack-'+indexDetail
        },
        changeImageId(indexDetail){
          return 'image-'+indexDetail
        },

        searchPackCommercialOffer(packOfferName) {
          if(this.packCommercialOffers.filter(x => x.name == packOfferName)[0]) {
            let number = this.packCommercialOffers.filter(x => x.name == packOfferName)[0].receipt.toFixed(2)
            let transformedNumber = this.decimalNumberWithCommas(number)
            return transformedNumber
          }
        },

        decimalNumberWithCommas(number) {
          if(number){
            let decimalCommaNumber = number.replace('.',',')
            return decimalCommaNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
          }
        },
        
        formatImporte(importe){
            if(!isNaN(importe)){

              return importe.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1.") + ' €'
              // return Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(importe).replace(/\D00(?=\D*$)/, '');
              // return Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(importe.toFixed(2));
            }
            return importe;
          },

    },
}
</script>
<style lang="scss">
#packs {
    .align{
          display: flex;
          align-items: center !important;
          justify-content: space-between;
      }

    // .more-info{
    //   font-style: normal;
    //   font-size:25px !important;
    //   float: left !important;
    //   margin-left: 10px;
    //   color:rgba(var(--vs-secundary), 1) !important;
    //   opacity: 1;
    //   font-weight:bold;
    //   cursor: pointer;
    //   // padding: 0px !important;
    //   border: none !important;
    //   // padding-bottom: 15px !important;

    // :hover {
    //   font-size:28px !important;
    //   }
    // }
    #pack-0 {
      border: 2px solid #FFCDD2 !important;
    }
    #pack-1 {
      border: 2px solid #EF9A9A !important;
    }
    #pack-2 {
      border: 2px solid #E57373 !important;
    }

    #image-0 {
      img{
        width: 50px;
        height: 50px;
        display:block;
        margin:auto;
        margin-top: 10px;
        margin-bottom: 10px;
      }
    }
    #image-1 {
      img{
        width: 60px;
        height: 60px;
        display:block;
        margin:auto;
        margin-top: 5px;
        margin-bottom: 5px;
      }
    }

    #image-2 {
      img{
        width: 70px;
        height: 70px;
        display:block;
        margin:auto;
      }
    }

      #buttons .next-button {
        display: none;
      }
  }

  .table-test {
    background: none !important;
    border-radius: 10%;
    display: inline-block;
    width: fit-content;
  }

  .categoryCapital{
    white-space:nowrap;
  }


  @media(max-width: 760px) {

    #packs {

      .packName{
        font-size: 17px;
      }

        .router-content {
          margin-top: -0.5rem !important;
        }

        .pack {
          margin-left: auto;
          margin-right: auto;
          .vs-col {
            width: 100% !important;
            }

          }

    }
  }

  @media only screen and (min-width : 600px)
    and (max-width : 760px) {
    #packs {

      .packName{
        font-size: 17px;
      }

      #buttons .call-button {
        float: right;
      }

      .pack {
          margin-left: 10%;
          margin-right: 10%;

          .vs-col .vs-col {
            width: 100%;
          }

        }

      }
    }

  @media(min-width: 761px) {

    #packs {

      .packName{
        font-size: 18px;
      }

        .pack {
          margin-left: auto;
          margin-right: auto;

          .vs-col .vs-col {
            width: 100%;
          }

        }

      #buttons .call-button button{
        float:right;

      }
      }
  }

  @media(max-width: 959px) {
  }
</style>